import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';
import 'moment-duration-format';

@Pipe({
    name: 'duration',
    standalone: false
})
export class DurationPipe implements PipeTransform {
  transform(value: number, useMoment: boolean = false, unit: any = 'millisecond'): string {
    if (useMoment) {
      return this.momentDuration(value, unit);
    }
    value = Math.abs(value);
    if (value < 1) {
      return '0';
    } else if (value < 2) {
      return '1 second';
    } else if (value < 60) {
      return value + ' seconds';
    } else if (value < 60 * 2) {
      return '1 minute';
    } else if (value < 60 * 60) {
      return Math.round(value / 60 * 10) / 10 + ' minutes';
    } else if (value < 60 * 60 * 2) {
      return '1 hour';
    } else if (value < 60 * 60 * 24) {
      return Math.round(value / (60 * 60) * 10) / 10 + ' hours';
    } else if (value < 60 * 60 * 24 * 2) {
      return '1 day';
    } else if (value < 60 * 60 * 24 * 7) {
      return Math.round(value / (60 * 60 * 24) * 10) / 10 + ' days';
    } else {
      return Math.round(value / (60 * 60 * 24) * 10) / 10 + ' days';
    }
  }

  private momentDuration(value: number, unit: any = 'millisecond'): string {
    const d = moment.duration(Math.abs(value), unit);
    return d.format('HH:mm:ss', { trim: false }).replace(/,/g, '');
  }
}
